import { css } from 'styled-components';

import { designColor } from './color';
import { styledLayout } from './layout';

const actionTokens = {
    // Should utilize `ActionSize / ActionVariant` enums for keys.
    default: {
        bgColor: {
            base: 'rgba(228, 164, 12, 0.1)',
            pressed: 'rgba(228, 164, 12, 1)',
        },
    },
    primary: {
        bgColor: {
            base: 'rgba(32, 128, 60, 0.1)',
            pressed: 'rgba(32, 128, 60, 1)',
        },
    },
    secondary: {
        bgColor: {
            base: 'rgba(94, 24, 248, 0.1)',
            pressed: 'rgba(94, 24, 248, 1)',
        },
    },
    destructive: {
        bgColor: {
            base: 'rgba(160, 0, 44, 0.1)',
            pressed: 'rgba(160, 0, 44, 1)',
        },
    },
    disabled: {
        bgColor: {
            base: 'rgba(62, 62, 62, 0.1)',
        },
        borderColor: {
            base: 'rgba(62, 62, 62, 1)',
        },
    },
};

const interactionDisable = css`
    pointer-events: none;
    touch-action: none;
    user-select: none;
`;

const interactionEnable = css`
    pointer-events: unset;
    touch-action: unset;
    user-select: unset;
`;

interface FocusRingArgs {
    width?: number;
    offset?: number;
    radius?: number;
    focusWithin?: boolean;
    pseudoAfter?: boolean;
    borderColor?: 'default' | 'invalid';
}

function focusRingVisible(visible = true) {
    return css`
        --yat_local-focus-ring-visible: ${visible ? 1 : 0};
    `;
}

function focusRing(args?: FocusRingArgs) {
    const width = args?.width ?? 2;
    const offset = args?.offset ?? 0;
    const radius = args?.radius ?? 0;

    const focusWithin = Boolean(args?.focusWithin);
    const pseudoAfter = Boolean(args?.pseudoAfter);

    const pseudoPosition = pseudoAfter ? 'after' : 'before';
    const focusWithinDeclaration = focusWithin
        ? css`
              &:focus-within {
                  ${focusRingVisible()};
              }
          `
        : undefined;

    return css`
        ${focusRingVisible(false)};
        position: relative;

        &::${pseudoPosition} {
            ${styledLayout.positionCover({ offset })};
            pointer-events: none;
            content: '';
            display: block;
            border: ${width}px solid
                ${args?.borderColor === 'invalid' ? actionTokens.destructive.bgColor.pressed : designColor.brandPurple};
            border-radius: ${radius}px;
            opacity: var(--yat_local-focus-ring-visible);
            // TODO: Motion values should come from 'theme'.
            transition: opacity 200ms ease-in-out;
        }

        // TODO: This should come from a global reset
        &:focus {
            outline: none;
        }

        &:focus-visible {
            ${focusRingVisible()};
        }

        ${focusWithinDeclaration};
    `;
}

export const styledInteraction = {
    interactionDisable,
    interactionEnable,
    focusRing,
};
